export default __webpack_public_path__ + "static/media/Verladung Porsche KS juli 2019 8_1.6c2aa752.jpg";